"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.openAsyncConnection = void 0;
const web_ui_framework_1 = require("@gruposantander/web-ui-framework");
const websocket_helper_1 = require("./websocket.helper");
const polling_helper_1 = require("./polling.helper");
const buildAsyncConnectionConfig = (mode, webSocketConfig, pollingConfig) => ({
    mode,
    webSocketConfig: {
        url: webSocketConfig.url,
    },
    pollingConfig: {
        interval: pollingConfig.interval,
        maxAttempts: pollingConfig.maxAttempts,
        getDataFn: pollingConfig.getDataFn,
    },
});
const openAsyncConnection = (mode, api, session, progressId, accessTokenFallback, challengeData, onResponse, urlConfig) => __awaiter(void 0, void 0, void 0, function* () {
    var _a;
    const accessToken = ((_a = session.getData()) === null || _a === void 0 ? void 0 : _a.accessToken) || accessTokenFallback;
    const webSocketConfig = (0, websocket_helper_1.getWebSocketConfig)(progressId, accessToken, urlConfig.websocketUrl);
    const trustedChallengeData = challengeData;
    const pollingConfig = (0, polling_helper_1.getPollingConfig)(api, progressId, trustedChallengeData.biometricId, urlConfig.pollingUrl);
    const asyncConnectionConfig = buildAsyncConnectionConfig(mode, webSocketConfig, pollingConfig);
    const asyncConnection = new web_ui_framework_1.AsyncConnection(asyncConnectionConfig);
    const connection = asyncConnection.getConnection();
    const asyncConnectionEvents = {
        onReceiveData: pushApproved => {
            if (pushApproved) {
                connection.disconnect();
                onResponse();
            }
        },
        onError: () => null,
    };
    yield connection.connect();
    connection.listen(asyncConnectionEvents);
    if (mode === web_ui_framework_1.AsyncConnectionMode.WEBSOCKET) {
        connection.send(JSON.stringify(webSocketConfig.request));
    }
    return connection;
});
exports.openAsyncConnection = openAsyncConnection;
//# sourceMappingURL=asyncConnection.helper.js.map